/**
 * Methods logic extracted from the ClientJS library
 * https://github.com/jackspirou/clientjs/blob/d7584e10a4e45a4a96d712cd4292465aeedc0218/src/client.js#L338
 */

import { isClient } from './utils/isClient';

const checkUserAgentProperty = () => isClient() && window.navigator?.userAgent;

export const isTouchDevice = () => !!(isClient() && 'ontouchstart' in window);

export const isAndroidDevice = () =>
  checkUserAgentProperty() && !!/Android/i.exec(window.navigator.userAgent);

export const isIOSDevice = () =>
  checkUserAgentProperty() && !!/iPhone|iPad|iPod/i.exec(window.navigator.userAgent);

export const isSafari = () =>
  checkUserAgentProperty() &&
  Boolean(/^((?!chrome|android).)*safari/i.exec(window.navigator.userAgent));
